import { render, staticRenderFns } from "./WhsN_CompanyProfile.vue?vue&type=template&id=56a8feb6"
import script from "./WhsN_CompanyProfile.vue?vue&type=script&lang=js"
export * from "./WhsN_CompanyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports